import ActionManager from '../../ActionManager';

import UpdateWidgetStatus from './UpdateWidgetStatus';
ActionManager.register(UpdateWidgetStatus, ['stores:MainStore']);

import UpdateWidgetOrder from './UpdateWidgetOrder';
ActionManager.register(UpdateWidgetOrder, ['stores:MainStore']);